

import { convertToRaw, EditorState } from 'draft-js';

const getContentState = (editorState) => {
  const contentState = editorState.getCurrentContent();
  const json = convertToRaw(contentState);
  const plainText = contentState.getPlainText();

  return {
    json,
    plainText
  };
};

export default getContentState;